import { render, staticRenderFns } from "./SendOrder.vue?vue&type=template&id=490f197b&scoped=true&"
import script from "./SendOrder.vue?vue&type=script&lang=js&"
export * from "./SendOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f197b",
  null
  
)

component.options.__file = "SendOrder.vue"
export default component.exports